/**
 * 大会参加者の生成
 */
import { TournamentParticipant } from '../types/Tournament';
import { MONSTER_DATABASE, HIDDEN_MONSTER_IDS } from '../constants/monsters';
import { AIConfig } from '../ai/types';

const CPU_COUNT = 7;

/**
 * プレイヤー1名 + ランダムCPU7名の参加者リストを生成する。
 *
 * CPU候補は通常キャラ＋解放済み隠しキャラの中からプレイヤー選択キャラを除いてランダムに選ぶ。
 *
 * @param playerMonsterId プレイヤーが選択したモンスターID
 * @param playerAIConfig プレイヤーのAI設定（オプション）
 * @param unlockedHiddenMonsterIds 解放済み隠しキャラのIDリスト
 * @throws モンスターIDが存在しない場合
 */
export function createParticipants(
  playerMonsterId: string,
  playerAIConfig?: AIConfig,
  unlockedHiddenMonsterIds: string[] = [],
): TournamentParticipant[] {
  const playerMonster = MONSTER_DATABASE.find((m) => m.id === playerMonsterId);
  if (!playerMonster) {
    throw new Error(`Monster not found: ${playerMonsterId}`);
  }

  const player: TournamentParticipant = {
    id: 'player',
    monsterId: playerMonsterId,
    isPlayer: true,
    wins: 0,
    losses: 0,
    draws: 0,
    points: 0,
    aiConfig: playerAIConfig,
  };

  const eligible = MONSTER_DATABASE.filter(
    (m) => m.id !== playerMonsterId &&
      (!HIDDEN_MONSTER_IDS.includes(m.id) || unlockedHiddenMonsterIds.includes(m.id)),
  );

  const shuffled = [...eligible].sort(() => Math.random() - 0.5);
  const cpus: TournamentParticipant[] = shuffled.slice(0, CPU_COUNT).map((m) => ({
    id: `cpu-${m.id}`,
    monsterId: m.id,
    isPlayer: false,
    wins: 0,
    losses: 0,
    draws: 0,
    points: 0,
  }));

  return [player, ...cpus];
}
